// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DWDM","col":"styles_col__39pxy"};